import axios from 'axios';

export const loadReceivingVirtualProviders = providerId => (
	axios.get(`/providers/${providerId}/view-receiving-virtual-providers`)
);

export const loadProvidingVirtualProviders = providerId => (
	axios.get(`/providers/${providerId}/view-providing-virtual-providers`)
);

export const addVirtualPractice = (adminId, practice_virtual_code) => (
	axios.post(`/providers/${adminId}/add-virtual-practice`, { practice_virtual_code })
);

export const approveVirtualPractice = (adminId, provider_practice_virtual_id) => (
	axios.post(`/providers/${adminId}/approve-virtual-practice`, { provider_practice_virtual_id: parseInt(provider_practice_virtual_id) })
);

export const loadProvidingVirtualPractices = (adminId) => (
	axios.get(`/providers/${adminId}/view-providing-virtual-practices`)
);

export const loadReceivingVirtualPractices = (adminId) => (
	axios.get(`/providers/${adminId}/view-receiving-virtual-practices`)
);

export const removeVirtualPractice = (adminId, provider_practice_virtual_id) => (
	axios.post(`/providers/${adminId}/remove-virtual-practice`, { provider_practice_virtual_id })
);

export const addVirtualProvider = (adminId, providerId, provider_practice_virtual_id) => (
	axios.post(`/providers/${adminId}/add-virtual-provider`, {
		providerId,
		provider_practice_virtual_id: parseInt(provider_practice_virtual_id)
	})
);

export const requestVirtualProvider = (adminId, provider_virtual_id) => (
	axios.post(`/providers/${adminId}/request-virtual-provider`, { provider_virtual_id: parseInt(provider_virtual_id) })
);

export const approveVirtualProvider = (adminId, provider_virtual_id) => (
	axios.post(`/providers/${adminId}/approve-virtual-provider`, { provider_virtual_id: parseInt(provider_virtual_id) })
);

export const removeVirtualProvider = (adminId, provider_virtual_id) => (
	axios.post(`/providers/${adminId}/remove-virtual-provider`, { provider_virtual_id: parseInt(provider_virtual_id) })
);
